import cloudImg from '../assets/images/cloud.jpg';
import ozImg from '../assets/images/rsz-oz.jpg';

/*****************************************
 * UI constants
 *****************************************/

export const uiData = {
  // select example text
  selectOptions: ['ריבועים', 'עננים', 'דחליל'],

  // clickable buttons with value
  // buttons: [
  //   {
  //     text: 'צעד אחד',
  //     value: 'step',
  //   },
  // ],

  // colors: ['#00426F', '#65C3A4', '#5765AE', '#59926E', '#453f78', '#30A3B0'],
};

/*****************************************
 * Examples constants and global variables
 *****************************************/

const data = {
  examples: [
    {
      headerText: `ריבועים`,
      subHeaderText: [
        'גודל התחלתי:',
        '2x2 px',
        'גודל סופי:',
        '220x220 px',
      ],
      calcInit: 'calcInit0',
      src: null,
      step: 20,
      maxScale: 120,
      initRepeat: 1,
      interval: 700,
    },
    {
      headerText: 'עננים',
      subHeaderText: ['גודל התחלתי:', '32x32 px', 'גודל סופי:', '320x320 px'],

      calcInit: 'calcInit1',
      src: cloudImg,
      step: 1,
      maxScale: 10,
      initRepeat: 1,
      interval: 700,
    },
    {
      headerText: '"דחליל"',
      subHeaderText: [
        'גודל התחלתי:',
        '100x100 px',
        'גודל סופי:',
        '500x500 px',
      ],

      calcInit: 'calcInit2',
      src: ozImg,
      step: 1,
      maxScale: 5,
      initRepeat: 1,
      interval: 500,
    },
  ],

  /*****************************************
   * Global variables
   *****************************************/

  exampleIdx: 0,
  lastExampleIdx: -1,
  scaleRatio: 2,

  size: {
    width: 500,
    height: 500,
  },

  state: 'new',
};

export default data;
